import { Rule } from '../types';

export const ruleCommercialFloor: Rule = (submission) => {
  if (submission.config.usage !== 'com') return null;
  if (submission.config.floor === 'plein') return null;

  return {
    ruleId: 'commercial-floor-plein',
    severity: 'error',
    humanMessage: `En commercial, le plancher PLEIN est obligatoire (Guide Go Rampe — sécurité).`,
    suggestion: {
      type: 'switch-floor',
      patch: {
        config: { ...submission.config, floor: 'plein' },
      },
    },
  };
};
